<template>
  <div class="dashboard-container">
    <div class="router-container">
      <transition name="fade">
        <router-view
          :key="$route.params.company_id"
          class="router-view" />
      </transition>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DashboardLayout',
    async mounted () {
      //init google analytics
      this.$ga.set('userId', this.$store.getters['auth/loggedInUser'].id)
      this.$ga.set('dimension1', this.$store.getters['auth/loggedInUser'].id)
    },
  }
</script>
<style lang="scss" scoped>
.dashboard-container {
  display: block;
  overflow: hidden;
  height: -webkit-fill-available;
  display: flex;
  flex-direction: column;
}
.router-container {
  background-color: $dashboard-bg;
  overflow-y: scroll;
  position: relative;
  flex-grow: 1;
}
</style>
